export const mapContactInfo = contact => ({
    email: contact?.email ?? 'N/A',
    phoneNumber: contact?.phoneNumber ?? 'N/A',
    jobTitle: contact?.jobTitle ?? 'N/A',
    leadName: contact?.leadName ?? 'N/A',
})
